import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { loginSchema } from '@waw/validation-schemas';
import { useAuth } from '../../auth/AuthContext.jsx';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [serverError, setServerError] = useState('');

  const from = location.state?.from || '/compte/profil';

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    setServerError('');
    try {
      await login(data.email, data.password);
      navigate(from, { replace: true });
    } catch (err) {
      if (err.status === 401) {
        setServerError('Email ou mot de passe incorrect.');
      } else if (err.status === 429) {
        setServerError('Trop de tentatives, réessayez dans quelques instants.');
      } else {
        setServerError(err.message || 'Une erreur est survenue.');
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1 className="auth-title">Connexion</h1>
        <p className="auth-subtitle">Accedez a votre espace WAW</p>

        {serverError && <div className="auth-error-banner">{serverError}</div>}

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-group">
            <label className="form-label" htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              className={`form-input${errors.email ? ' error' : ''}`}
              placeholder="votre@email.com"
              autoComplete="email"
              {...register('email')}
            />
            {errors.email && <span className="form-error">{errors.email.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="login-password">Mot de passe</label>
            <input
              id="login-password"
              type="password"
              className={`form-input${errors.password ? ' error' : ''}`}
              placeholder="Votre mot de passe"
              autoComplete="current-password"
              {...register('password')}
            />
            {errors.password && <span className="form-error">{errors.password.message}</span>}
          </div>

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={isSubmitting}>
            {isSubmitting ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="auth-footer auth-links">
          <Link to="/compte/mot-de-passe-oublie">Mot de passe oublie ?</Link>
          <span>
            Pas encore de compte ?{' '}
            <Link to="/compte/inscription">Creer un compte</Link>
          </span>
        </div>
      </div>
    </div>
  );
}
